import { ShieldCheck } from 'lucide-react';
import { WidgetContainer } from '../../infrastructure/widgets/WidgetContainer';
import { WidgetConfig } from '../../infrastructure/contracts/widget.contract';
import { StatisticsCard } from '../../infrastructure/widgets/cards/StatisticsCard';
import { useGodModeAdapter } from './adapters/godModeAdapter';

export interface GodModeWidgetProps {
  config: WidgetConfig;
}

export function GodModeWidget({ config }: GodModeWidgetProps) {
  const { data: deferred, isLoading, isError, error, refetch } = useGodModeAdapter();

  const isWidgetLoading = isLoading || deferred?.loading;
  const widgetError = isError 
    ? error?.message 
    : deferred?.error;

  const metrics = deferred?.data;

  return (
    <WidgetContainer
      config={config}
      isLoading={isWidgetLoading}
      isError={!!widgetError}
      errorMessage={widgetError}
      onRefresh={refetch}
    >
      <div className="flex flex-col gap-4 rounded-card border border-outline bg-surface p-4">
        <div className="flex items-center gap-2">
          <span className="flex h-7 w-7 items-center justify-center rounded-DEFAULT bg-primary-container text-on-primary-container">
            <ShieldCheck className="h-4 w-4" />
          </span>
          <h3 className="text-data-lg font-semibold text-on-surface">God Mode Overview</h3>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-4">
          <StatisticsCard
            title="Total Tasks"
            primaryValue={metrics?.totalTasks ?? 0}
            color="primary"
          />
          <StatisticsCard
            title="Active Tasks"
            primaryValue={metrics?.activeTasks ?? 0}
            color="info"
          />
          <StatisticsCard
            title="Completed"
            primaryValue={metrics?.completedTasks ?? 0}
            color="success"
          />
          <StatisticsCard
            title="Overdue"
            primaryValue={metrics?.overdueTasks ?? 0}
            color="error"
          />
          <StatisticsCard
            title="Departments"
            primaryValue={metrics?.totalDepartments ?? 0}
            color="warning"
          />
          <StatisticsCard
            title="Employees"
            primaryValue={metrics?.totalEmployees ?? 0}
            color="primary"
          />
          <StatisticsCard
            title="Prod. Score"
            primaryValue={`${metrics?.productivityScore ?? 0}%`}
            color="info"
          />
        </div>
      </div>
    </WidgetContainer>
  );
}
